import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { track } from "../lib/track";

export function PublicLayout() {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); track("pageview", pathname); }, [pathname]);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    window._hsq = window._hsq || [];
    if (email) window._hsq.push(["identify", { email }]);
    window._hsq.push(["setPath", window.location.pathname + window.location.search]);
    window._hsq.push(["trackPageView"]);
  }, [pathname, search]);
  useEffect(() => {
    if (document.getElementById("hs-script-loader")) return;
    const s = document.createElement("script");
    s.id = "hs-script-loader"; s.type = "text/javascript"; s.async = true; s.defer = true;
    s.src = "//js-na2.hs-scripts.com/244882256.js";
    document.body.appendChild(s);
  }, []);
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1"><Outlet /></main>
      <SiteFooter />
    </div>
  );
}
